"use client";
import TailwindAdvancedEditor from "@/components/tailwind/advanced-editor";
import { defaultCompanionKey, companions, type CompanionKey } from "@/lib/companions";
import { useEffect, useMemo, useState } from "react";
import ScaleContainer from "@/components/tailwind/ui/scale-container";
import { useSearchParams } from "next/navigation";

export default function Page() {
  const search = useSearchParams();
  const [companionKey, setCompanionKey] = useState<CompanionKey>(defaultCompanionKey);
  useEffect(() => {
    const saved = window.localStorage.getItem("companionKey") as CompanionKey | null;
    if (saved && companions[saved]) setCompanionKey(saved);
  }, []);
  useEffect(() => {
    window.localStorage.setItem("companionKey", companionKey);
  }, [companionKey]);

  // Always enable the sidebar regardless of iframe embedding
  const enableSidebar = true;

  return (
    <div className="flex min-h-screen flex-col items-center pb-6 px-4">
      <ScaleContainer baseWidth={860} minScale={0.55} maxScale={1}>
        <TailwindAdvancedEditor companionKey={companionKey} sidebarEnabled={enableSidebar} />
      </ScaleContainer>
    </div>
  );
}
